export function doExport(
  vm,
  {
    selectedTableData = [],
    idField,
    exportIdField,
    params,
    dto,
    specialForm,
    selectedExportSpecialParams,
    fuc,
    fucParams,
    normalExportSpecialParams,
  }
) {
  let result = [];
  if (selectedTableData.length) {
    if (!exportIdField) {
      exportIdField = idField;
    }
    let temp = [];
    selectedTableData.map((item) => {
      temp.push(item[idField]);
    });
    result = [
      {
        fieldName: exportIdField,
        conditionalType: "6",
        fieldValue: temp.join(","),
      },
    ];
    if (selectedExportSpecialParams) {
      result = result.concat(selectedExportSpecialParams);
    }
  } else {
    result = params.result;
    if (normalExportSpecialParams) {
      console.log(normalExportSpecialParams);

      result = result.concat(normalExportSpecialParams);
    }
  }
  if (specialForm) {
    vm[specialForm].openExportLoading = true;
  } else {
    vm.openExportLoading = true;
  }

  vm.$api
    .post("/api/Derive/GetDeriveModel", dto)
    .then((res) => {
      if (specialForm) {
        vm[specialForm].openExportLoading = false;
        vm[specialForm].exportItemNameData = res.data;
        vm[specialForm].batchQueryFields = res.data.batchQueryFields;
        vm[specialForm].erportRes = result;
        vm.$refs[specialForm + "exportTable"].openExportDialog(
          res.data.tableName
        );
        if (fuc) {
          fuc(fucParams);
        }
      } else {
        vm.openExportLoading = false;
        vm.exportItemNameData = res.data;
        vm.batchQueryFields = res.data.batchQueryFields;
        vm.erportRes = result;
        vm.$refs["exportTable"].openExportDialog(res.data.tableName);
        if (fuc) {
          fuc(fucParams);
        }
      }
    })
    .catch(() => {
      vm.openExportLoading = false;
    });
}
